import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {LinkSchema} from './link'
import {AssetSchema} from './asset'
import {CardIconColors} from '@primer/react-brand/esm'
import {RichTextSchema} from '../richText'
import {safeOptional} from '../../safe-optional'

export const FeaturedBentoSchema = buildEntrySchemaFor('featuredBento', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      heading: RichTextSchema,
      headingLevel: z.enum(['h2', 'h3', 'h4', 'h5', 'h6']).optional(),
      link: LinkSchema,
      icon: z.string().optional(),
      iconColor: z.enum(CardIconColors).optional(),
      image: safeOptional(AssetSchema),
      imageMobile: safeOptional(AssetSchema),
    }),
  ),
})

export type FeaturedBentoType = z.infer<typeof FeaturedBentoSchema>
